import { IProductView } from "@app/products/products.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const detailsAdapter: EntityAdapter<IProductView> = createEntityAdapter<IProductView>({
	selectId: product => product.sku
});